import { COMPETITION_CODE } from '@api/competitions/constants';

export const formatWASEventName = ({
  categoryCode,
  subCategoryName,
  venue,
  startDateYear,
  name,
  showIdList,
  eventIdWa,
}) => {
  if (categoryCode === COMPETITION_CODE.WORLD_ATHLETICS_SERIES) {
    return `${showIdList ? eventIdWa + ' - ' : ''}${subCategoryName}, ${venue}, ${startDateYear}`;
  }

  return name;
};
